import { useEffect, useRef } from 'react';
import queryString from 'query-string';
import buildIdentityProps from './identity';
import useAnalyticsClient from './use-analytics-client';
import { getLocale } from '../helpers/locale';

// Sets common props and calls identify once, as soon as a userProfileId is available.
const useAnalyticsIdentity = () => {
  const client = useAnalyticsClient();
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (identifiedRef.current || !client) return;

    const params = queryString.parse(window.location.search);

    if (!params.userProfileId) return;

    identifiedRef.current = true;
    client.setCommonProps(buildIdentityProps(params, getLocale()));
    client.identify();
  }, [client]);
};

export default useAnalyticsIdentity;
